<template>
  <div class="layer">
    <div class="inner" :class="{isReadonly: isReadonly}">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{ locale.option_preset }}</h2>
      <div class="flexBox">
        <div class="flexInner">
          <div class="mb15 isRequired">
            <div class="innerTitle setLabel">{{locale.name}}</div>
            <input type="text" class="input" :disabled="isReadonly" v-model="name">
          </div>
          <div class="mb15 isRequired">
            <div class="innerTitle setLabel">{{ locale.preset_options }}</div>
            <div v-if="options.length > 0" class="shopOptionList">
              <draggable
                v-model="options"
                :disabled="isReadonly"
                handle=".btnHandle"
                group="optionList"
                animation="300"
                class="optionList draggable"
                tag="ul">
                <li
                  v-for="(opt, index) in options"
                  :key="index"
                  class="optionItem">
                  <button type="button" class="btnDel" :disabled="isReadonly" @click="delOption(index)"></button>
                  <button type="button" class="btnHandle" :disabled="isReadonly"></button>
                  <div class="optionName" :disabled="isReadonly" @click="setDetailOption(opt.id)">
                    <span v-if="opt.items" class="stkr">Preset</span>
                    {{ opt.name[defaultLang] }}
                    <!-- 프리셋일 때 프리셋 구성 옵션 -->
                    <div v-if="opt.items" class="optionItems">
                      <div
                        v-for="(item, idx) in opt.items"
                        :key="idx"
                        class="presetItem">
                        {{ item.name }}
                      </div>
                    </div>
                    <!-- //프리셋일 때 프리셋 구성 옵션 -->
                  </div>
                </li>
              </draggable>
            </div>
            <div v-else>{{ locale.alert_preset_options }}</div>
          </div>
        </div>
        <div v-if="!isReadonly" class="flexInner">
          <div class="innerTitle setLabel">{{ locale.options_all }}</div>
          <p class="infoMessage">{{ locale.message_preset_options }}</p>
          <OptionListAll
            :locale="locale"
            :filterIds="optionItemIds"
            :disabled="isReadonly"
            @clicked="addOptionItem" />
        </div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" :disabled="!isValid || isReadonly" @click="save">{{ locale.save }}</button>
      </div>
    </div>
    <CreateOption
      v-if="detailOption"
      :locale="locale"
      :id="detailOption"
      :isApply="isApply"
      @close="setDetailOption(null)" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import CreateOption from './CreateOption'
import OptionListAll from './OptionListAll'

export default {
  name: 'CreateOptionPreset',
  props: [
    'locale',
    'presetId',
    'isApply', //샵아이템에서 직접 옵션을 만들 경우
    'optionData'
  ],
  components: {
    draggable,
    CreateOption,
    OptionListAll
  },
  computed: {
    defaultLang () {
      const langInfo = this.$store.state.setting.lang
      return langInfo.default
    },
    isReadonly () {
      return this.presetId && this.presetId !== 'new' && this.isApply //샵아이템에서 옵션구성을 할 때 스토어에 있는 옵션인 경우
    },
    isValid () {
      const name = regExp.replaceAllEmpty(this.name) !== ''
      const optionItem = this.options.length > 1
      return name && optionItem
    },
    optionItemIds () {
      return this.options.map(x => x.id)
    },
    filteredListAll () {
      const itemsIds = this.optionItemIds
      const list = this.optionListAll
      return list.filter(x => !itemsIds.includes(x.id))
    }
  },
  created () {
    if (this.presetId && this.presetId !== 'new') {
      this.getShopPresetDetail()
    }
  },
  data () {
    return {
      name: '',
      options: [],
      optionListAll: [],
      detailOption: null
    }
  },
  methods: {
    async getShopPresetDetail () {
      this.$store.commit('onLoading', true)
      const getDetail = await this.$store.dispatch('shop/getShopPresetDetail', {
        presetType: 'option',
        presetId: this.presetId
      })
      const detail = getDetail && getDetail.message
      if (detail && detail.presetId) {
        this.name = detail.presetName
        this.options = detail.presetOptions
      }
      this.$store.commit('onLoading', false)
    },
    addOptionItem (item) {
      this.options.push(item)
    },
    delOption (index) {
      this.options = this.options.filter((x, i) => i !== index)
    },
    setDetailOption (optionId) {
      this.detailOption = optionId
    },
    close () {
      this.$emit('close')
    },
    async save () {
      const presetId = this.presetId && this.presetId !== 'new' && this.presetId
      const data = {
        presetType: 'option',
        presetId: presetId || UNIQUE.uniqueId8(),
        presetName: this.name,
        presetOptions: this.optionItemIds
      }
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('shop/putShopPreset', data)
      if (res && res.status === 200) {
        alert(this.locale.complete_save)
        this.$emit('reload')
        this.close()
      }
      this.$store.commit('onLoading', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 720px;
  }
  .isReadonly {
    max-width: 400px;
  }
}
.isRequired {
  .innerTitle {
    padding-left: 18px;
    &:after {
      content: "*";
      position: absolute;
      top: 0;
      left: 8px;
      color: $color-red;
    }
  }
}
</style>
